// extracted by mini-css-extract-plugin
export default {"section":"section_section__YdKXa","sectionTitle":"section_sectionTitle__FGuXv","separator":"section_separator__udVok","fieldContainer":"section_fieldContainer__8jPMY"};